import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DetailComponent, NotificationService } from 'pmv-common';
import { PMVAuthenticationService } from 'pmv-common';
import { DadosAcumuloCargo } from '../../models/dadosAcumuloCargo.model';
import { Inscricao } from '../../models/inscricao-model';
import { RouteNavigationService } from '../../services/api/route-navigation.service';
import { ConvocacaoService } from '../../services/convocacao.service';

@Component({
  selector: 'pmv-candidato-convocado',
  templateUrl: './candidato-convocado.component.html',
  styleUrls: ['./candidato-convocado.component.scss']
})

export class CandidatoConvocadoComponent extends DetailComponent implements OnInit {
  subtitle: string;
  loading: Boolean = false;
  editalAnoPss: string;
  inscricao: Inscricao;

  constructor(
    private routeDataService: RouteNavigationService,
    private route: ActivatedRoute,
    private authenticationService: PMVAuthenticationService,
    private convocacaoService: ConvocacaoService,
    private readonly notificationService: NotificationService,
  ) { super(route); }

  handleValidSubmission(form: NgForm): void {
  }

  ngOnInit(): void {
    this.loading = true;
    const canActivate = this.authenticationService.isUserLoggedIn();
    if (canActivate) {
      const tk = this.authenticationService.getToken();
    } else {
      this.authenticationService.redirectToLoginPage();
      return;
    }

    this.subtitle = 'Aqui você irá acompanhar todo o seu processo de convocação';
    this.getCarregarDadosInscricao();
    this.loading = false;
  }

  getCarregarDadosInscricao() {
    this.inscricao = this.routeDataService.getDataCandidatoConvocado();
    if (!this.inscricao) {
      this.loading = false;
      this.routeDataService.toAcompanhamentoInscricao();
      return;
    }

    this.editalAnoPss = 'Edital ' + this.inscricao.anoNumeroEdital + ' - ' + this.inscricao.cargoFuncao;
  }

  goDadosAdicionais() {
    this.routeDataService.fromAnyToDadosAdicionais(this.inscricao);
  }

  goDeclaracaoAcumuloCargo() {

    var dadosAcumulo = new DadosAcumuloCargo();
    dadosAcumulo.numeroInscricao = this.inscricao.nrInscricao;
    dadosAcumulo.codigoConcurso = this.inscricao.concurso;

    this.convocacaoService.postConsultaDeclaracaoAcumuloCargoPreenchida(dadosAcumulo)
      .subscribe(res => {
        if (res.data != undefined) {
          this.notificationService.notifySuccess("Declarção de Acúmulo de Cargo já foi preenchida com sucesso.");
          return;
        }
        else {
          this.routeDataService.fromAnyToDeclaracaoAcumuloCargo(this.inscricao);
        }
      }, error => {
        throw error;
      });
  }

  desistirConvocacao() {
    this.routeDataService.fromAnyToDesistirConvocacao(this.inscricao);
  }

  voltar(): void {
    this.routeDataService.toAcompanhamentoInscricao();
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/candidato-convocado/candidato-convocado.component.ts